/**
 * 这个工具主要的是处理ID的方法
 */

import authService from '../abs/services/auth/authService';
import commonUtils from './commonUtils';
class IdsUtil {
  /**
   * 产品ID
   */
  static dealId: null | string | number = null;
  /**
   * reits专区ID
   */
  static reitsId: null | string | number = null;
  /**
   * 机构ID
   */
  static organizationId: null | string | number = null;
  /**
   * 证券ID
   */
  static securityId: null | string | number = null;

  static setIds(payload: any, params: any) {
    const dealID = payload.dealID ? payload.dealID : params.dealID;
    const reitsID = payload.reitsID ? payload.reitsID : params.reitsID;
    const organizationID = payload.organizationID ? payload.organizationID : params.organizationID;
    const securityID = payload.securityID ? payload.securityID : params.securityID;
    this.dealId = dealID;
    this.reitsId = reitsID;
    this.securityId = securityID;
    this.organizationId = organizationID;
    return { dealID, organizationID, securityID, reitsID };
  }

  static getProductId(state: any) {
    const { product } = state;
    const { isReits } = product;
    const reitsID = commonUtils.getValue(state, 'global.params.reitsID', null);
    const dealID = commonUtils.getValue(state, 'global.params.dealID', null);
    return isReits ? reitsID : dealID;
  }

  static setConferenceId(ids: any) {
    if (!commonUtils.isEmpty(ids)) {
      localStorage.removeItem(authService.conferenceCacheKey);
      localStorage.setItem(authService.conferenceCacheKey, JSON.stringify(ids));
    }
  }

  static getConferenceId() {
    const data = localStorage.getItem(authService.conferenceCacheKey);
    if (data) {
      const { id } = JSON.parse(data);
      return id;
    }
    return '';
  }

  static getConferenceResultId() {
    const data = localStorage.getItem(authService.conferenceCacheKey);
    if (data) {
      const { result_id } = JSON.parse(data);
      return result_id;
    }
    return '';
  }
}

export default IdsUtil;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/idsUtil.ts